<template>
  <div class="store-container">
    <div class="content-header-container">
      <div class="header-title-container yg-jalnan">
        <p class="content-title">{{ title }}</p>
        <p class="content-subtitle indent">{{ highlighten }}</p>
      </div>
      <div class="header-title-more">
        <p class="content-title-more s-core-dream-regular">더보기</p>
      </div>
    </div>

    <div>
      <horizontal-scroll class="horizontal-scroll">
        <div class="outer">
          <div class="inner-content" v-for="item in posts1">
            <a :href="item.link">
              <img class="content-img" :src="item.thumbnail" />
              <p class="content-desc s-core-dream-regular">
                {{ item.contents }}
              </p>
            </a>
          </div>
        </div>
      </horizontal-scroll>
    </div>
  </div>
</template>

<script>
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
import firebase from "firebase";

export default {
  name: "store-container",
  components: {
    HorizontalScroll,
  },
  data() {
    return {
      posts1: [],
    };
  },
  props: ["title", "highlighten", "location"],
  mounted() {
    if (this.location) {
      firebase
        .firestore()
        .collection("posts1")
        .where("location", "==", this.location)
        .get()
        .then((snap) => {
          const testCollection = [];
          snap.forEach((doc) => {
            console.log(doc.data());
            testCollection.push(doc.data());
          });

          this.posts1 = testCollection;
        });
    }
  },
};
</script>

<style scoped>
.store-container {
  margin-top: 16px;
  margin-bottom: 32px;
}

.content-header-container {
  display: flex;
  justify-content: space-between;
  height: 35px;
  margin-bottom: 10px;
}

.header-title-container {
  display: flex;
}

.content-title {
  font-size: 17px;
}

.content-subtitle {
  color: #f9730c;
  font-size: 24px;
}

p.indent {
  padding-left: 0.4em;
}

.content-title-more {
  color: grey;
  margin-top: 8px;
}

/* sdsafasfsa */
.horizontal-scroll {
  display: flex;
  width: 100%;
  height: 186px;
  /* border: solid 2px #2c3e50; */
}
.outer {
  display: flex;
  flex: 1;
  width: auto;
  height: 100%;
  flex-flow: row nowrap;
}

.content-img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 0px 1px 15px 0px #cbcbcb;
}

.inner-content {
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 120px;
  height: 150px;
  /* border: solid 1px #2c3e50; */
}

@media (min-width: 640px) {
  .horizontal-scroll {
    height: 220px;
  }
  .inner-content {
    width: 150px;
    height: 180px;
  }
}

@media (min-width: 768px) {
  .horizontal-scroll {
    height: 250px;
  }
  .inner-content {
    width: 180px;
    height: 210px;
  }
}

@media (min-width: 1024px) {
  .horizontal-scroll {
    height: 280px;
  }

  .inner-content {
    width: 210px;
    height: 240px;
  }
}

.content-desc {
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.inner-content:not(:first-of-type) {
  margin-left: 15px;
}
</style>
